import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Emoji from '../../../../../components/Emoji/Emoji';

const useStyles = makeStyles(({ spacing, palette }) => ({
  title: {
    fontSize: 32,
    lineHeight: 1.25,
    fontWeight: 'bold',
    marginBottom: spacing(2),
  },
  link: {
    display: 'inline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  emailText: {
    fontWeight: 'bold',
    color: palette.green.fruitSalad,
  },
}));

export interface ICongratulationTitleProps {
  title?: string;
  recipientEmail: string;
  gl?: string;
  isGiftCard?: boolean;
}

const CongratulationTitle = ({
  title = 'Hooray!',
  recipientEmail,
  gl = 'gift',
  isGiftCard = false,
}: ICongratulationTitleProps) => {
  const classes = useStyles();
  return (
    <Box pt={[2, 8]} pb={2} mx={[2, 'auto']} color="text.primary" textAlign="center">
      <Typography className={classes.title} data-testid="congratulationHeader">
        {title} <Emoji emoji="claps" />
        <Emoji emoji="partyPopper" />
        <Emoji emoji="partyFace" />
        <Emoji emoji="confettiBall" />
      </Typography>
      {!isGiftCard && (
        <Typography className="Lato-Regular" data-testid="congratulationHeaderBody">
          Your {gl} details have been sent to your email <span className={classes.emailText}>{recipientEmail}</span>.
        </Typography>
      )}
    </Box>
  );
};

export default memo(CongratulationTitle);
